import moment from 'moment';
import { Grid, Typography } from '@mui/material';

import { CompanyTypeLabelEnum, getAddressText } from '@utils/constants';

import {
  ILabelValueProp,
  LabelValueListVertical,
} from '@features/workspace/components/label-value-list';
import { useAppSelector } from '@store/hooks';
import { selectActiveCompany } from '@features/workspace/store/selectors';
import config from '@/app/configs/config';

export function CompanySummary() {
  const company = useAppSelector(selectActiveCompany);

  const propertiesLeft: Array<ILabelValueProp> = [
    { label: 'Registered business name', value: company?.name || null },
    {
      label: 'Type',
      value: company ? CompanyTypeLabelEnum[company?.companyType] : null,
    },
    { label: 'Address', value: getAddressText(company?.address) },
    { label: 'Website', value: company?.website || null },
  ];

  const propertiesRight: Array<ILabelValueProp> = [
    {
      label: 'Registration number',
      value: company?.registrationNumber || null,
    },
    {
      label: 'Registration date',
      value: company?.businessRegistrationDate
        ? moment(company?.businessRegistrationDate).format(config.dateFormat)
        : null,
    },
    { label: 'Tax number', value: company?.taxNumber || null },
    { label: 'VAT number', value: company?.vatRegistrationNumber || null },
  ];

  if (company === null) {
    return (
      <Typography className="labelHeader" variant="subtitle2">
        <i>No company defined!</i>
      </Typography>
    );
  }

  return (
    <>
      <Grid container sx={{ width: '100%' }}>
        <Grid item sx={{ paddingRight: '20px' }} xs={6}>
          <LabelValueListVertical properties={propertiesLeft} />
        </Grid>
        <Grid item xs={6}>
          <LabelValueListVertical properties={propertiesRight} />
        </Grid>
      </Grid>
    </>
  );
}
